import validarCpf from '../../util/validarCpf';

const CPF_ISENTO = '11111111111';

export const digitosCpf = value => String(value || '').replace(/\D/g, '');

export const cpfParaConsulta = value => {
  const digitos = digitosCpf(value);
  if (digitos.length !== 11 || digitos === CPF_ISENTO) return null;
  if (!validarCpf(digitos)) return null;
  return digitos;
};

export const outrosPacientesComCpf = (pacientes, codPacAtual) => {
  const lista = Array.isArray(pacientes) ? pacientes : [];
  if (codPacAtual === undefined || codPacAtual === null || codPacAtual === '') {
    return lista;
  }
  const atual = String(codPacAtual);
  return lista.filter(paciente => String(paciente.CODPAC) !== atual);
};
